import React from 'react'
import ZeusAd from 'components/ZeusAd'
import ImageAttribution from 'components/ImageAttribution'
import ImageTrackingPixel from 'components/ImageTrackingPixel'

const Gallery = ({ story, adSettings = false }) => {
  const {
    post_type_meta: { gallery }
  } = story
  if (!gallery) return null
  let adIndex = 0
  let showAd = false
  return (
    gallery &&
    gallery.images.map((item, idx) => {
      if (idx === 1 || (idx - 1) % 5 === 0) {
        showAd = true
        adIndex++
      } else {
        showAd = false
      }
      return (
        <div className='hq-image' key={idx}>
          <img src={`${gallery.base}${item.image}`} alt='' />
          <ImageTrackingPixel url={item?.attribution?.view_tracking_url ?? null} />
          {item.attribution && <ImageAttribution attribution={item.attribution} />}
          {showAd && adSettings && (
            <div className='freestarAd__unit freestarAd__unit--gallery'>
              <ZeusAd id={`In-Article-${adIndex}`} index={idx} adSettings={adSettings} />
              <style jsx>{`
                .freestarAd__unit {
                  text-align: center;
                  margin-bottom: 15px;
                }
              `}</style>
            </div>
          )}
        </div>
      )
    })
  )
}

export default Gallery
